import { FirestoreDataConverter } from '@angular/fire/firestore';
import { Settings } from './settings.base';
import { SettingsEnum } from '../enums/settings.enum';
import { ObjectHelper } from "../helpers/object.helper";

export class MultipressSettings extends Settings {
  type = SettingsEnum.MULTIPRESS;
  /** List of statuses for state Wait for quotation */
  waitQuotationStates: string[];
  /** Status for new quotation */
  quotationNewState: string;
  /** Status for state Wait for quotation validation */
  quotationValidationState: string;
  /** List of statuses for state Wait for file */
  waitFileStates: string[];
  /** Status for state Wait for file */
  waitFileState: string;
  /** Status for state Printing */
  printingState: string;
  /** The state for To be process */
  processingState: string;
  /** id of the checklist to indicate if a sub job has a file to process */
  filesId: string;
  /** id of the checklist to indicate if a sub job has a callas script */
  scriptId: string;
  /** id of the checklist to indicate the sub job format */
  formatId: string;
  /** id of the checklist to indicate the production information */
  productionInformationId: string;
  /** id of the subjob standard to indicate a sold express delivery */
  expressDeliveryId: string;
  /** id of the MP Shipment delivery method to indicate delivery is a pickup  */
  pickUpDeliveryId: string;
  /** id of the MP Shipment delivery method to indicate delivery is a courier */
  courierDeliveryId: string;
  /** id of the MP Shipment delivery method to indicate delivery is a charter */
  charterDeliveryId: string;
  /** State for Quotation accepted */
  quotationAcceptedState: string;
  /** State for Quotation refused */
  quotationRefusedState: string;
  /** State for BAT accepted */
  batAcceptedState: string;
  /** State for BAT refused */
  batRefusedState: string;
  /** State for wait for BAT */
  waitBatState: string;
  /** State for Archived */
  archiveState: string;
  /** id of the checklist to indicate the of contacts */
  contactsId: string;
  /** id of the checklist to link support */
  supportId: string;
  /** id of the checklist to link finishing */
  finishingId: string;
  /** State for ready to ship */
  readyToShipState: string;
  /** State for ready to set order to invoice */
  setToInvoiceState: string;
  /** State for ready to invoice */
  readyToInvoiceState: string;
  /** State for shipped */
  shippedState: string;
  /** State for unpaid order */
  unpaidState: string;
  /** Automatic handling of stock by MP */
  automaticStock: boolean;
  /** Whether automatic stock entries/exits are paused */
  stockAutomaticPaused: boolean;
  syncQuotations: boolean;
  syncQuotationStartId: number;
  syncOrders: boolean;
  syncOrdersStartId: number;
  /** Planning section */
  planning: {
    /** Let the planning update data outside of it (Multipress status on PAO close, shipments site on punch) */
    updateOutsidePlanning: boolean;
  };
  syncShipments: boolean;
  shipmentsRetention: number;
  /** Minutes ahead during which auto-planning keeps the announced order */
  planningFrozenMinutes: number;
  /** Multipress numbers of the customers with their own carrier: their pickups are planned as one-day deliveries */
  planningCustomerCarrierErpIds: string[];
  syncInvoices: boolean;
  checkPurchaseOrder: boolean;
  syncInvoicesStartId: number;
  stockStates: string[];
  url: string;
  login: string;
  password: string;
  isActive: boolean;
  /** Allowed MP SubJobs descriptions without a price */
  allowedNoPriceProducts: string[];
  /** Blocking MP SubJobs descriptions */
  blockingInvoicingProducts: string[];
  /** Blocking MP production types descriptions */
  blockingInvoicingProductionTypes: string[];
  /** id of the checklist to link conditioning */
  conditioningId: string;
  /** String value for internal production type */
  productionKey: number;
  /** String value for external production type */
  externalProductionKey: number;
  /** String value for other prestation type */
  otherPrestationKey: number;
  /** String value for installation type */
  installationKey: number;
  /** String value for transport type */
  transportKey: number;
  /** id of the checklist to link comment */
  information: string;

  constructor(data?: Partial<MultipressSettings>) {
    super(data);
    this.waitQuotationStates = data?.waitQuotationStates ?? [];
    this.quotationValidationState = data?.quotationValidationState ?? '';
    this.quotationNewState = data?.quotationNewState ?? '';
    this.waitFileStates = data?.waitFileStates ?? [];
    this.processingState = data?.processingState ?? '';
    this.filesId = data?.filesId ?? '';
    this.scriptId = data?.scriptId ?? '';
    this.formatId = data?.formatId ?? '';
    this.quotationAcceptedState = data?.quotationAcceptedState ?? '';
    this.quotationRefusedState = data?.quotationRefusedState ?? '';
    this.batAcceptedState = data?.batAcceptedState ?? '';
    this.batRefusedState = data?.batRefusedState ?? '';
    this.waitFileState = data?.waitFileState ?? '';
    this.printingState = data?.printingState ?? '';
    this.waitBatState = data?.waitBatState ?? '';
    this.archiveState = data?.archiveState ?? '';
    this.contactsId = data?.contactsId ?? '';
    this.readyToShipState = data?.readyToShipState ?? '';
    this.setToInvoiceState = data?.setToInvoiceState ?? '';
    this.readyToInvoiceState = data?.readyToInvoiceState ?? '';
    this.shippedState = data?.shippedState ?? '';
    this.automaticStock = data?.automaticStock ?? false;
    this.stockAutomaticPaused = data?.stockAutomaticPaused ?? false;
    this.syncQuotations = data?.syncQuotations ?? false;
    this.syncQuotationStartId = data?.syncQuotationStartId ?? 0;
    this.syncOrders = data?.syncOrders ?? false;
    this.syncOrdersStartId = data?.syncOrdersStartId ?? 0;
    this.planning = { updateOutsidePlanning: data?.planning?.updateOutsidePlanning ?? false };
    this.syncShipments = data?.syncShipments ?? false;
    this.shipmentsRetention = data?.shipmentsRetention ?? 30;
    this.planningFrozenMinutes = data?.planningFrozenMinutes ?? 60;
    this.planningCustomerCarrierErpIds = [...(data?.planningCustomerCarrierErpIds ?? [])];
    this.syncInvoices = data?.syncInvoices ?? false;
    this.syncInvoicesStartId = data?.syncInvoicesStartId ?? 0;
    this.stockStates = data?.stockStates ?? [];
    this.productionInformationId = data?.productionInformationId ?? '';
    this.expressDeliveryId = data?.expressDeliveryId ?? '';
    this.pickUpDeliveryId = data?.pickUpDeliveryId ?? '';
    this.courierDeliveryId = data?.courierDeliveryId ?? '';
    this.charterDeliveryId = data?.charterDeliveryId ?? '';
    this.url = data?.url ?? '';
    this.login = data?.login ?? '';
    this.password = data?.password ?? '';
    this.unpaidState = data?.unpaidState ?? '';
    this.supportId = data?.supportId ?? '';
    this.finishingId = data?.finishingId ?? '';
    this.isActive = data?.isActive ?? false;
    this.allowedNoPriceProducts = data?.allowedNoPriceProducts ?? [];
    this.blockingInvoicingProducts = data?.blockingInvoicingProducts ?? [];
    this.blockingInvoicingProductionTypes = data?.blockingInvoicingProductionTypes ?? [];
    this.conditioningId = data?.conditioningId ?? '';
    this.productionKey = data?.productionKey ?? -1;
    this.externalProductionKey = data?.externalProductionKey ?? -1;
    this.otherPrestationKey = data?.otherPrestationKey ?? -1;
    this.installationKey = data?.installationKey ?? -1;
    this.transportKey = data?.transportKey ?? -1;
    this.information = data?.information ?? '';
    this.checkPurchaseOrder = data?.checkPurchaseOrder ?? false;
  }

  /**
   * Multipress customer numbers typed in a field: separated by commas (semicolons, spaces and new lines work too),
   * without blanks or duplicates
   * @param text The text typed
   * @returns The numbers, in the order typed
   */
  static parseErpIds(text: string): string[] {
    return [...new Set((text ?? '').split(/[,;\s]+/).filter(erpId => erpId.length > 0))];
  }

  converter: FirestoreDataConverter<MultipressSettings> = {
    toFirestore: (settings: MultipressSettings) => {
      settings.transportKey = Number(settings.transportKey);
      settings.productionKey = Number(settings.productionKey);
      settings.externalProductionKey = Number(settings.externalProductionKey);
      settings.otherPrestationKey = Number(settings.otherPrestationKey);
      settings.installationKey = Number(settings.installationKey);
      // Mirrors the backend's own clamp (_frozenOrderMinutes in fb-auto-planning.service.js) so what
      // is displayed always matches what is actually applied: an empty, invalid or negative field
      // keeps the default window instead of saving something the cron would silently reinterpret,
      // and the value is rounded and capped at the same 480-minute maximum.
      const raw = settings.planningFrozenMinutes as unknown;
      // Number(null) and Number('') are both 0, not NaN, so blank/absent must be checked explicitly
      const frozenMinutes = raw === null || raw === undefined || raw === '' ? NaN : Number(raw);
      settings.planningFrozenMinutes = Number.isFinite(frozenMinutes) && frozenMinutes >= 0 ?
        Math.min(Math.round(frozenMinutes), 480) : 60;
      settings.planningCustomerCarrierErpIds = MultipressSettings.parseErpIds(
        (settings.planningCustomerCarrierErpIds ?? []).join(','));
      const obj = ObjectHelper.anonymize(settings);
      delete obj.converter;
      delete obj.type;
      delete obj.id;
      return obj;
    },
    fromFirestore: (snapshot, options) =>
      new MultipressSettings({ ...snapshot.data(options), id: snapshot.id })
  };
}
